import axios from "axios";

// 요청마다 JWT 자동 첨부
axios.interceptors.request.use((config) => {
	const token = localStorage.getItem("accessToken");
	if (token && config.headers && !config.url?.startsWith("/api/portfolios/")) {
		config.headers.Authorization = `Bearer ${token}`;
	}
	return config;
});

// 응답 인터셉터
axios.interceptors.response.use(
	(response) => response,
	(error) => {
		const originalUrl = error.config?.url || "";

		// ✅ 비로그인 허용 API 목록
		const publicApis = [
			"/api/auth/",
            "/api/portfolios/",
			"/api/user/me",
			"/api/board/search", // 🔥 통합 검색 (recent 포함)
		];

		const isPublicApi = publicApis.some((url) =>
			originalUrl.includes(url)
		);

		if (
			error.response &&
			error.response.status === 401 &&
			!isPublicApi
		) {
			localStorage.removeItem("accessToken");
			window.dispatchEvent(new Event("storage"));

			if (window.location.pathname !== "/") {
				window.location.href = "/";
			}
		}

		return Promise.reject(error);
	}
);

export default axios;
